import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';

import { setDisplayModal } from '@/redux/app/appSlice';

import closeImage from '@/images/close.svg';

import Portal from '@/ui/portal';

import s from './modal.module.css';

function Modal({ close, children }) {
  const dispatch = useDispatch();

  const opened = useSelector(appSelectors.displayModal);

  const handleClose = () => {
    dispatch(setDisplayModal(false));

    const delayedAction = setTimeout(() => {
      close();
      clearTimeout(delayedAction);
    }, 300);
  };

  const backdropStyles = opened ? s.backdrop : s.backdrop_hidden;
  const modalStyles = opened ? s.modal : s.modal_hidden;

  useEffect(() => {
    dispatch(setDisplayModal(true));
  }, [dispatch]);

  return (
    <Portal>
      <div className={backdropStyles} onClick={handleClose}>
        <div className={modalStyles} onClick={e => e.stopPropagation()}>
          {/* <div className={backdropStyles} onClick={e => e.stopPropagation()}>
        <div className={modalStyles}> */}
          <button
            type="button"
            onClick={handleClose}
            className={s.btn_close}
            title="close"
          >
            <img src={closeImage} alt="close" />
          </button>
          {children}
        </div>
      </div>
    </Portal>
  );
}

export default Modal;

Modal.propTypes = {
  close: PropTypes.func,
  children: PropTypes.node,
};
